<template>
  <div v-if="info">
      <div class="p1">
        <div class="logo"  v-if="user.company && user.company.logo">
            <img :src="user.company.logo"/>
        </div>
        <div class="logo" v-else>
            <img src="../../../../images/logo@2x.png" />
        </div>
        <div class="title">{{user.company.short}}中医健康评估报告</div>
        <div class="time">检测时间：{{info.created_at}}</div>
        <div class="portrait">
            <img :src="user.url" v-if="user.url" />
            <img src="../../../../images/user.png" v-else />
        </div>
        <div class="nikeName">{{info.user_name?info.user_name:(user.nikeName?user.nikeName:'')}}</div>
        <ul class="info">
            <li class="flex">
                <div>年龄：</div>
                <div class="flex-1 bottom">
                    {{info.age}}岁
                </div>
            </li>
            <li class="flex">
                <div>身高：</div>
                <div class="flex-1 bottom">
                    {{info.height}}cm
                </div>
            </li>
            <li class="flex">
                <div>体重：</div>
                <div class="flex-1 bottom">
                    {{info.weight}}kg
                </div>
            </li>
            <li class="flex">
                <div>手机号：</div>
                <div class="flex-1 bottom">
                    {{user.phone?user.phone:''}}
                </div>
            </li>
        </ul>
        <!-- <div class="warning">郑重提醒：本报告不作医学诊断及购药依据之用</div> -->
      </div>
      <template v-for="(pageConfig, pageIndex) in pageList">
        <div class="p2" :key="pageIndex" v-if="isPageVisible(pageConfig)">
          <component
            v-for="moduleName in pageConfig.modules"
            :key="moduleName"
            :is="getComponentName(moduleName)"
            :show-modules="allModuleNames"
            :is-print="true"
          />
        </div>
      </template>
  </div>
</template>
<script>
import modules from '../module';
import { getPageConfig, getModuleNames, MODULE_COMPONENT_MAP } from '../module/helpers';

export default {
    name: 'print',
    props: ["user", "info", "MBItext", "module", "logo", "logoName"],
    components: {
        ...modules
    },
    computed: {
        pageList() {
            return getPageConfig();
        },
        allModuleNames() {
            return getModuleNames().filter(name => name !== '用户的基础信息');
        }
    },
    methods: {
        getComponentName(moduleName) {
            return MODULE_COMPONENT_MAP[moduleName];
        },
        isPageVisible(pageConfig) {
            if (pageConfig.validateKeys && pageConfig.validateKeys.length > 0) {
                return pageConfig.validateKeys.every(key => this.info && this.info[key]);
            }
            return true;
        }
    }
}
</script>
<style lang="scss" scoped>
  @import './print';
</style>
